import { CommonModule, DecimalPipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbAccordionModule, NgbDatepickerModule, NgbModalModule, NgbNavModule, NgbTimepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { ComponentBaseService } from './components/component.base.service';
import { DisabledPermissionDirective } from './components/permissions/disabled-permission.directive';
import { HasPermissionDirective } from './components/permissions/permission.directive';
import { PortalHeaderComponent } from './components/portal-header/portal-header.component';
import { StandardComponentsModule } from './components/standard-components/standard-components.module';
import { DeactivationGuard } from './services/deactivation-guard/deactivation-guard.service';
import { CustomToastComponent } from './services/notifications-service/custom-toastr/custom-toast.component';
import { NotificationsService } from './services/notifications-service/notifications.service';
import { PermissionsService } from './services/permissions/permissions.service';
import { TranslocoRootModule } from './transloco/transloco-root.module';

export const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsColor: 'var(--nav_item_active)',
    fgsColor: 'var(--active_accent_color)',
    fgsSize: 40,
    bgsSize: 40,
    blur: 3,
    pbColor: 'var(--nav_item_active)',
    delay: 200,
    maxTime: 30000,
    minTime: 300,
    pbThickness: 5,
};

@NgModule({
    declarations: [CustomToastComponent, PortalHeaderComponent, HasPermissionDirective, DisabledPermissionDirective],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbAccordionModule,
        NgbNavModule,
        NgbModalModule,
        NgbTooltipModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        TranslocoRootModule,
        StandardComponentsModule,
        NgSelectModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbNavModule,
        NgbModalModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        NgbAccordionModule,
        NgbTooltipModule,
        NgxUiLoaderModule,
        PortalHeaderComponent,
        TranslocoRootModule,
        StandardComponentsModule,
        NgSelectModule,
        HasPermissionDirective,
        DisabledPermissionDirective,
    ],
    providers: [DecimalPipe, DeactivationGuard, NotificationsService, ComponentBaseService],
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [PermissionsService, NotificationsService],
        };
    }
}
